var configureColors = function configureColors(widgetConfig, customConfig) {

    if (customConfig) return customConfig;

    var ChartConfig = widgetConfig.ChartConfig;

    if (ChartConfig && ChartConfig.ColorPalette) return ChartConfig.ColorPalette;
};

export default configureColors;